import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { Grid, IconButton } from '@mui/material'
import RedCrossIcon from '../../Icons/RedCrossIcon'
import MUIButton from '../MUI-Button'
import MUIMultiselectAsset from '../MUI-Multiselect-Asset/MUI-Multiselect-Asset'
import MUITooltip from '../MUI-Tooltip'

const JSONInputField1: React.FC<any> = ({
  fieldId,
  index,
  label,
  error,
  fields,
  addMore,
  addMoreRemoveAction,
  formFieldsOptions,
  onInputChange,
  showAddmoreIcon = false,
}: any) => {
  const getErrorObject = (item: any) => {
    if (!item.errorMessage) return {}
    return { [item.fieldName]: { message: item.errorMessage } }
  }
  return (
    <>
      {fields?.map((fieldsArray: any, fieldsIndex: number) =>
        !showAddmoreIcon ? (
          <div
            key={`json-input-${fieldId}-${fieldsIndex}`} // NOSONAR
            className='partner-asset-type-config-wrapper'
          >
            <div className='text-left config-title'>
              <p className='center-vertical'>
                {label} {fields?.length > 1 ? fieldsIndex + 1 : ''}
              </p>
              {fields?.length > 1 && !showAddmoreIcon && (
                <div
                  className='ml-auto cursor-pointer red-cross-icon'
                  onClick={() => addMoreRemoveAction('', index, fieldsIndex, false, fieldId)}
                  data-testid='remove-json1-field'
                >
                  <RedCrossIcon />
                </div>
              )}
            </div>
            <div className='config-form'>
              <Grid container columnSpacing={10} rowSpacing={4}>
                {fieldsArray.map((field: any, fieldIndex: number) => {
                  let options = field?.options
                  if (
                    field?.formFieldsOptionsKey &&
                    formFieldsOptions[field.formFieldsOptionsKey]
                  ) {
                    options = formFieldsOptions[field.formFieldsOptionsKey]
                  }
                  return (
                    <>
                      <Grid
                        item
                        xs={6}
                        md={6}
                        lg={6}
                        xl={6}
                        key={field?.options + '_' + field.formFieldsOptionsKey}
                      >
                        <MUIMultiselectAsset
                          id={field?.fieldName}
                          name={field?.fieldName}
                          className='autocomple-class'
                          multiple={field?.isMultiple}
                          label={field?.label}
                          options={options}
                          value={field?.value}
                          labelKey={field?.labelKey}
                          required={field?.validations?.required}
                          error={getErrorObject(field)}
                          onInputChange={(_ev: any, newValue: any) => {
                            onInputChange({
                              ev: newValue,
                              index,
                              item: field,
                              fieldsIndex,
                              fieldIndex,
                            })
                          }}
                        />
                      </Grid>
                    </>
                  )
                })}
              </Grid>
            </div>
          </div>
        ) : (
          <div
            key={`json-input-${fieldId}-${fieldsIndex}`} // NOSONAR
            className='complex-config-wrapper'
          >
            {fieldsIndex === 0 ? (
              <>
                <div className='text-left config-title'>
                  <p>{label}</p>
                </div>
                {error ? <div className='text-left config-title field-error'>{error}</div> : null}
              </>
            ) : (
              <></>
            )}

            <Grid container columnSpacing={5} rowSpacing={4} className=''>
              {fieldsArray.map((field: any, fieldIndex: number) => {
                let options = field?.options
                if (field?.formFieldsOptionsKey && formFieldsOptions[field.formFieldsOptionsKey]) {
                  options = formFieldsOptions[field.formFieldsOptionsKey]
                }
                return (
                  <Grid
                    item
                    xs={4.9}
                    md={4.9}
                    lg={4.9}
                    xl={4.9}
                    key={field?.options + '_' + field?.formFieldsOptionsKey}
                  >
                    <MUIMultiselectAsset
                      id={field?.fieldName}
                      name={field?.fieldName}
                      className='autocomple-class'
                      multiple={field?.isMultiple}
                      label={field?.label}
                      options={options}
                      value={field?.value}
                      labelKey={field?.labelKey}
                      required={field?.validations?.required}
                      error={getErrorObject(field)}
                      onInputChange={(_ev: any, newValue: any) => {
                        onInputChange({ ev: newValue, index, item: field, fieldsIndex, fieldIndex })
                      }}
                    />
                  </Grid>
                )
              })}

              <Grid item xs={0.5} lg={0.5} className='center-vertical'>
                {fieldsIndex === 0 ? (
                  <IconButton
                    className='icon-button'
                    data-testid='add__icon_complextype'
                    onClick={() => addMoreRemoveAction('', index, null, true, fieldId)}
                  >
                    <MUITooltip title='Add New Value' disableInteractive={true}>
                      <AddCircleOutlineIcon className='fs-25' />
                    </MUITooltip>
                  </IconButton>
                ) : (
                  <IconButton
                    className='icon-button'
                    data-testid='remove__icon_complextype'
                    onClick={() => addMoreRemoveAction('', index, fieldsIndex, false, fieldId)}
                  >
                    <MUITooltip title='Remove Value' disableInteractive={true}>
                      <RemoveCircleOutlineIcon className='fs-25' />
                    </MUITooltip>
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </div>
        ),
      )}

      {addMore && !showAddmoreIcon && (
        <Grid key={`json-input-${fieldId}`} item xs={12} className='d-flex justify-content-end'>
          <MUIButton
            width={160}
            height='48px'
            textTransform={'capitalize'}
            variant='outlined'
            size='large'
            color={'secondary'}
            type='button'
            label={'+ Add More'}
            handleClickCB={() => addMoreRemoveAction('', index, null, true, fieldId)}
          />
        </Grid>
      )}
    </>
  )
}
export default JSONInputField1
